export const SEND_SALE_ORDER  = 'SEND_SALE_ORDER ';

export const SEND_SALE_ORDER_SUCCESS = 'SEND_SALE_ORDER_SUCCESS';

export const SEND_SALE_ORDER_FAILED = 'SEND_SALE_ORDER_FAILED';